export * from "./types.js";
export * from "./copy.js";
export {
  assertNoCreditHandoff,
  calculateLmiCost,
  calculatePayNowVsSaveTo20,
  calculateRefundOnDischarge,
} from "./calculate.js";
export { lmiCostFy2025_26, refundOnDischargeFy2025_26 } from "./fy2025-26.js";

import type { FinancialYear } from "../types.js";
import type { LmiCostRuleSet, RefundOnDischargeRuleSet } from "./types.js";
import { lmiCostFy2025_26, refundOnDischargeFy2025_26 } from "./fy2025-26.js";

/** Registry of indicative LMI-cost grids by period. Historical periods stay
 * registered so re-runs resolve against the grid in force then. */
export const LMI_COST_RULESETS: Record<string, LmiCostRuleSet> = {
  "2025-26": lmiCostFy2025_26,
};

/** Registry of refund-on-discharge scales by period. */
export const LMI_REFUND_RULESETS: Record<string, RefundOnDischargeRuleSet> = {
  "2025-26": refundOnDischargeFy2025_26,
};

/** Resolve the indicative LMI-cost grid for a period, or throw if unknown. */
export function lmiCostRulesFor(fy: FinancialYear): LmiCostRuleSet {
  const rules = LMI_COST_RULESETS[fy];
  if (!rules) throw new Error(`no LMI-cost ruleset registered for ${fy}`);
  return rules;
}

/** Resolve the refund-on-discharge scale for a period, or throw if unknown. */
export function lmiRefundRulesFor(fy: FinancialYear): RefundOnDischargeRuleSet {
  const rules = LMI_REFUND_RULESETS[fy];
  if (!rules) throw new Error(`no LMI-refund ruleset registered for ${fy}`);
  return rules;
}

/** Most recent LMI ruleset period — the default for live "this year" calcs. */
export const LMI_CURRENT_FY: FinancialYear = "2025-26";
